import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import { addProjectContributors } from '@services/projects.service';
import { invalidateProjectQueries } from './projectQueryInvalidation';

/**
 * @param {string} projectId
 * @returns {{ addContributors: (body: { userIds: string[] }) => void, isPending: boolean }}
 */
export function useAddProjectContributors(projectId) {
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: (body) => addProjectContributors(projectId, body),
        onSuccess: () => {
            invalidateProjectQueries(queryClient, projectId);
            message.success('Collaborators invited.');
        },
        onError: (err) => {
            message.error(err?.response?.data?.message || err?.message || 'Failed to invite collaborators.');
        },
    });

    const addContributors = (body, callbacks = {}) => {
        mutation.mutate(body, {
            onSuccess: callbacks.onSuccess,
            onError: callbacks.onError,
        });
    };

    return {
        addContributors,
        isPending: mutation.isPending,
    };
}
